const FILTER_PARAM_NAMES = [
    "employeeId",
    "departmentId",
    "teamId",
    "teamRoleId",
    "clientType",
];

export const buildWorkloadDrilldownHref = (
    appliedFilters = {},
    rowFilters = {},
) => {
    const filters = { ...appliedFilters, ...rowFilters };
    const searchParams = new URLSearchParams();

    FILTER_PARAM_NAMES.forEach((paramName) => {
        const value = filters[paramName];
        if (value !== null && value !== undefined && value !== "") {
            searchParams.set(paramName, value);
        }
    });

    searchParams.set(
        "includeInactive",
        String(Boolean(filters.includeInactive)),
    );

    return `/filteredClients?${searchParams.toString()}`;
};
